"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskLauncher = exports.mediaAssets = void 0;
const helpers_1 = require("./tasks/shared/helpers");
require("./styles/index.scss");
const taskConfig_1 = __importDefault(require("./tasks/taskConfig"));
const taskStore_1 = require("./taskStore");
const taskStore_2 = require("./taskStore");
const utils_1 = require("./utils");
// @ts-ignore: Need to keep sentry as .js file to use new function-based API
const sentry_js_1 = require("./sentry.js");
const getBucketName_1 = require("./tasks/shared/helpers/getBucketName");
const constants_1 = require("./tasks/shared/helpers/constants");
const camelCase_1 = __importDefault(require("lodash/camelCase"));
// let sharedMediaAssets: MediaAssetsType;
let languageAudioAssets;
let sharedAudioAssets;
let taskVisualAssets;
let sharedVisualAssets;
class TaskLauncher {
    constructor(firekit, gameParams, userParams, logger) {
        this.gameParams = gameParams;
        this.userParams = userParams;
        this.firekit = firekit;
        utils_1.Logger.setInstance(logger, gameParams, userParams);
    }
    async init() {
        var _a, _b, _c;
        (0, sentry_js_1.initSentry)();
        await this.firekit.startRun();
        const { taskName } = this.gameParams;
        let { language } = this.gameParams;
        (0, taskStore_2.taskStore)('language', language);
        // Levante handling
        // adding this to handle legacy two letter language codes in variant docs
        if (language === 'es') {
            language = 'es-CO';
        }
        else if (language === 'en') {
            language = 'en-US';
        }
        else if (language === 'de') {
            language = 'de-DE';
        }
        const { setConfig, getCorpus, buildTaskTimeline, getTranslations } = taskConfig_1.default[(0, helpers_1.dashToCamelCase)(taskName)];
        const isDev = ((_c = (_b = (_a = this.firekit.firebaseProject) === null || _a === void 0 ? void 0 : _a.firebaseApp) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.projectId) === 'gse-roar-assessment-dev';
        const useRoarHfBucket = (0, helpers_1.isRoarApp)(this.firekit) && taskName === 'hearts-and-flowers';
        let taskVisualBucket, sharedVisualBucket, languageAudioBucket, sharedAudioBucket;
        if (taskName !== 'roar-inference' && taskName !== 'trog') {
            taskVisualBucket = (0, getBucketName_1.getBucketName)(taskName, isDev, 'visual', language, useRoarHfBucket);
            sharedVisualBucket = (0, getBucketName_1.getBucketName)('shared', isDev, 'visual', language, useRoarHfBucket);
            languageAudioBucket = (0, getBucketName_1.getBucketName)('shared', isDev, 'audio', language, useRoarHfBucket);
            sharedAudioBucket = (0, getBucketName_1.getBucketName)('shared', isDev, 'audio', 'shared', useRoarHfBucket);
        }
        try {
            if (taskName === 'roar-inference' || taskName === 'trog') {
                // ROAR buckets use only the language code, not the full locale
                language = language.includes('-') ? language.split('-')[0] : language;
                exports.mediaAssets = await (0, helpers_1.getRoarMediaAssets)(constants_1.TASK_BUCKET_NAMES_ORIGINAL[(0, camelCase_1.default)(taskName)], {}, language);
            }
            else {
                languageAudioAssets = await (0, helpers_1.getMediaAssets)(languageAudioBucket, {}, language, taskName);
                sharedAudioAssets = await (0, helpers_1.getMediaAssets)(sharedAudioBucket, {}, 'shared', taskName);
                taskVisualAssets = await (0, helpers_1.getMediaAssets)(taskVisualBucket, {}, language, taskName);
                sharedVisualAssets = await (0, helpers_1.getMediaAssets)(sharedVisualBucket, {}, language, 'shared');
            }
        }
        catch (error) {
            throw new Error('Error fetching media assets: ' + error);
        }
        const config = await setConfig(this.firekit, this.gameParams, this.userParams);
        (0, taskStore_1.setTaskStore)(config);
        if (taskName === 'roar-inference' || taskName === 'trog') {
            await (0, helpers_1.getRoarTranslations)(language);
        }
        else {
            await getTranslations(isDev, taskName, language);
        }
        // TODO: make hearts and flowers corpus? make list of tasks that don't need corpora?
        if (taskName !== 'hearts-and-flowers' && taskName !== 'memory-game' && taskName !== 'intro') {
            await getCorpus(config, isDev);
        }
        if (taskName !== 'roar-inference' && taskName !== 'trog') {
            await (0, helpers_1.getAssetsPerTask)(isDev, useRoarHfBucket);
            const taskAudioAssetNames = [
                ...(0, taskStore_2.taskStore)().assetsPerTask[taskName].audio,
                ...(0, taskStore_2.taskStore)().assetsPerTask.shared.audio,
            ];
            // filter out language audio not relevant to current task
            languageAudioAssets = (0, helpers_1.filterMedia)(languageAudioAssets, [], taskAudioAssetNames, []);
            exports.mediaAssets = (0, helpers_1.combineMediaAssets)([languageAudioAssets, sharedAudioAssets, taskVisualAssets, sharedVisualAssets]);
        }
        // Expose resolved media assets for e2e validation (dev/test only)
        if (typeof window !== 'undefined') {
            window.__mediaAssets = exports.mediaAssets;
        }
        return buildTaskTimeline(config, exports.mediaAssets);
    }
    async run() {
        (0, helpers_1.showLevanteLogoLoading)();
        const { jsPsych, timeline } = await this.init();
        (0, helpers_1.hideLevanteLogoLoading)();
        const logger = utils_1.Logger.getInstance();
        logger.capture('Task Launched', {
            taskName: this.gameParams.taskName,
            language: this.gameParams.language,
            gameParams: this.gameParams,
            userParams: this.userParams,
        });
        jsPsych.run(timeline);
        const translations = (0, taskStore_2.taskStore)().translations;
        const pageSetup = new utils_1.InitPageSetup(4000, translations);
        (0, taskStore_2.taskStore)('pageSetup', pageSetup);
        pageSetup.init();
        await (0, helpers_1.isTaskFinished)(() => { var _a, _b; return ((_b = (_a = this.firekit) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.completed) === true && (0, taskStore_2.taskStore)().taskComplete; });
    }
}
exports.TaskLauncher = TaskLauncher;
